import { render, staticRenderFns } from "./ContactFilesList.vue?vue&type=template&id=185130af&"
import script from "./ContactFilesList.vue?vue&type=script&lang=js&"
export * from "./ContactFilesList.vue?vue&type=script&lang=js&"
import style0 from "./ContactFilesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports